class GoldFabricsAnnouncementTicker extends HTMLElement {
  #controller;
  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const paused = this.dataset.paused !== 'true';
      this.dataset.paused = String(paused);
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? 'Resume moving announcements' : 'Pause moving announcements');
    }, { signal: this.#controller.signal });
  }
  disconnectedCallback() { this.#controller?.abort(); }
}
if (!customElements.get('gf-announcement-ticker')) customElements.define('gf-announcement-ticker', GoldFabricsAnnouncementTicker);
